import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import store from './store'
import global from '@/utils/global'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'


Vue.use(ElementUI)
Vue.use(api)

Vue.prototype.global = global

// 解决刷新不展示问题的迂回方案，直接跳转到首页
var href = window.location.href
if(href.endsWith("#/") == false && href.endsWith("#/login") == false){  
  window.location.href = href.substr(0,href.indexOf('#/') + 2)
}else if(href.indexOf('#/') < 0){
  if(href.endsWith("/") == false){
    window.location.href = href + "/#/"
  }else{
    window.location.href = href + "#/"
  }
}

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js